module.exports = __webpack_public_path__ + "media/images/icons/filled/rest-f353236477fd67aca6d97f9a225c1d60.svg";